import { Phone, MessageSquareText } from 'lucide-react';
import { business } from '../../mock';

// GA4 event helper — safe if gtag isn't ready yet.
function trackEvent(name, params = {}) {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
}

/**
 * Slim, always-visible bottom bar for mobile visitors.
 * Two equal-width buttons: Call (tel:) and Quote (scrolls to contact form
 * or opens the QuoteModal if a handler is provided).
 * Fires GA4 events so we can measure how many calls/quotes the bar drives.
 * Hidden on xl+ where the desktop header + hero CTAs are plenty.
 */
export default function MobileCallBar({ onQuoteClick }) {
  const handleCall = () => {
    trackEvent('mobile_bar_call_tap', {
      event_category: 'engagement',
      event_label: 'mobile_call_bar',
      phone: business.phone,
      page_path: typeof window !== 'undefined' ? window.location.pathname : '',
    });
    // Also fire the GA4-recommended "generate_lead" style event for conversion tracking.
    trackEvent('generate_lead', {
      event_label: 'phone_call',
      value: 1,
      currency: 'AUD',
      method: 'mobile_bar',
    });
  };

  const handleQuote = () => {
    trackEvent('mobile_bar_quote_tap', {
      event_category: 'engagement',
      event_label: 'mobile_call_bar',
      page_path: typeof window !== 'undefined' ? window.location.pathname : '',
    });
    if (onQuoteClick) return onQuoteClick();
    // Ask the current page (whichever one is mounted) to open its QuoteModal.
    // Each page listens for 'vglm:open-quote' and flips its local state.
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('vglm:open-quote', { detail: { source: 'mobile_call_bar' } }));
    }
  };

  return (
    <>
      <div className="xl:hidden h-[68px]" aria-hidden="true" />

      <div
        className="xl:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0A2E18] border-t border-[#D98A00]/40 shadow-[0_-8px_24px_rgba(0,0,0,0.25)]"
        style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
        data-testid="mobile-call-bar"
        role="region"
        aria-label="Quick contact"
      >
        <div className="flex divide-x divide-white/10">
          <a
            href={`tel:${business.phone}`}
            onClick={handleCall}
            className="flex-1 flex items-center justify-center gap-2 py-4 text-white font-bold text-[15px] active:bg-white/5 transition-colors"
            data-testid="mobile-call-bar-call"
          >
            <Phone className="w-5 h-5 text-[#D98A00]" aria-hidden="true" />
            Call Now
          </a>
          <button
            type="button"
            onClick={handleQuote}
            className="flex-1 flex items-center justify-center gap-2 py-4 bg-[#D98A00] text-[#0A2E18] font-extrabold text-[15px] active:bg-[#B86F00] transition-colors"
            data-testid="mobile-call-bar-quote"
          >
            <MessageSquareText className="w-5 h-5" aria-hidden="true" />
            Free Quote
          </button>
        </div>
      </div>
    </>
  );
}
